module.exports = __webpack_public_path__ + "img/2415941-98-7.3dc74044.png";